import type { GetBrandResponse } from '@vue-storefront/prestashop-api';
import { useSdk } from '~/sdk';

interface BrandState {
  data: GetBrandResponse['psdata'] | null;
  pending: boolean;
  error: Error | null;
}

export const useBrand = () => {
    const state = useState<BrandState>(() => ({
        data: null,
        pending: false,
        error: null,
    }));

    
    async function fetchBrand() {
        state.value.pending = true;

        try {
            const { id } = useProductParams();
            const data = await useSdk().commerce.getBrand({id});
            state.value.data = data;
        } catch (error) {
            useHandleError(error);
        } finally { 
            state.value.pending = false;
        }
    }

    return { 
        data: computed(() => state.value.data),
        pending: computed(() => state.value.pending),
        error: computed(() => state.value.error),
        fetchBrand,
    };
}; 

